import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import styles from './GroupList.module.less';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupList, openGroup, getTurnList } from '../../../actions/wallpaperPay';
import config from '../config';
import Loading from '../../../components/Loading/Loading';
import GroupItem from './GroupItem';
import Toast from '../../../components/Toast/Toast';
import { PCStoreJsBridge } from '../../../nativeapi';
import { addClass } from '../../../utils/utils';
import { logging } from '../../../actions/log';

const selectGroupList = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.groupList,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const groupList = useSelector(selectGroupList);
  const [showList, setShowList] = useState();
  const listNode = useRef(null);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    dispatch(getGroupList());
  }, []);

  useEffect(() => {
    setShowList(groupList.list);
  }, [groupList]);

  const closeGroup = () => {
    addClass(listNode.current, styles.group_list_out);
  };

  const handleSub = useCallback(async () => {
    let res = await config.addWpToTurn({ contentList: groupList.choiceList, type: '2' });
    if (res?.status === 0) {
      dispatch(openGroup(false));
      Toast.success({
        content: '已成功添加至轮播列表',
      });
      dispatch(getTurnList({ pageCursor: '', refresh: true }));
      if (window.external && window.external.get_wallpaper_carousel_switch_info) {
        let switchData = JSON.parse(window.external.get_wallpaper_carousel_switch_info()) || {};
        if (switchData.switch === 'off') {
          PCStoreJsBridge.switchWpOpenTurn({
            switch: 'on',
            duration: switchData.duration,
          }).then(res => {
            if (res) {
              window.PCStore_WpMine_TurnUpdate();
              dispatch(
                logging({
                  category: 'Wallpaper',
                  action: 'R_Wallpaper_Loop_Start',
                  label: '',
                  param2: {
                    source: `Wallpaper_Mine||loop`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    Looptype: 2,
                  },
                }),
              );
            }
          });
        }
      }
    } else if (![0, 1, 2, 3].includes(res?.status)) {
      Toast.error({
        content: '设置失败',
      });
    } else {
      Toast.error({
        content: res.message,
      });
    }
  }, [groupList]);

  const handleClose = () => {
    closeGroup();
  };

  return (
    <div className={styles.wp_group_mask}>
      <div className={styles.wp_group_other} onClick={handleClose} />
      <div
        className={styles.group_list}
        onAnimationEnd={e => {
          if (e?.target?.className && e?.target?.className.indexOf(styles.group_list_out) > -1) {
            setTimeout(() => {
              dispatch(openGroup(false));
            }, 300);
          }
        }}
        ref={listNode}
      >
        <div className="shadow" />
        <div className="list">
          <div className="list_header">
            <div className="header_back" onClick={closeGroup}>
              <i className="iconfont icon-opt_back" />
            </div>
            <div className="header_control">
              <div className="control_text">选择我的轮播壁纸</div>
              <div className="control_btn" onClick={handleSub}>
                完成
              </div>
            </div>
          </div>
          <div className="list_info">
            {groupList.load && <Loading />}
            {!groupList.load && (
              <>
                {showList?.map((el, index) => (
                  <div key={index}>
                    <div className="item_title">{el.groupName}</div>
                    <div className="item_img_list">
                      {el.contents.map((item, itemIndex) => (
                        <GroupItem key={itemIndex} item={item} />
                      ))}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
